import { apiGet, apiSend } from "./api";
import { Lead } from "./types";

export async function listLeads(): Promise<Lead[]> {
  const data = await apiGet("/admin/leads");
  return data.leads as Lead[];
}

export async function deleteLead(id: string): Promise<void> {
  await apiSend("DELETE", `/admin/leads/${id}`);
}
